// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__NiuSn","watchWrapper":"Timer_watchWrapper__bVBws","title":"Timer_title__g3KtN"};